import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  PRODUCT_ADD_PATH,
  PRODUCT_PATH,
  PRODUCT_UPDATE_PATH,
} from "utils/constants/paths";

const Partners = Loadable(React.lazy(() => import("./View")));
const PartnersAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);

export const ProductRoute: IRouteItem = {
  path: PRODUCT_PATH,
  iconName: "ShoppingBag",
  element: React.createElement(Partners),
  name: "Products",
  accessKeys: ["ContentCreator"],
  children: [
    {
      name: "Add / Update",
      path: PRODUCT_ADD_PATH,
      element: React.createElement(PartnersAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: PRODUCT_UPDATE_PATH,
      element: React.createElement(PartnersAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
